/**
 * @generated SignedSource<<822daa603b9d1174575048ab408cd2ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoListItem_todo$data = {
  readonly body: string | null;
  readonly canChangeStatus: boolean;
  readonly canWrite: boolean;
  readonly formattedBody: string | null;
  readonly id: string;
  readonly isOrg: boolean;
  readonly ordinal: string;
  readonly response: {
    readonly __typename: string;
  } | null;
  readonly status: TodoStatus;
  readonly " $fragmentSpreads": FragmentRefs<"TodoCircleStatusWithResponse_todo" | "TodoListItemFooter_todo" | "TodoListItemHeader_todo" | "TodoListItemMainContentDetails_todo" | "TodoListItemMainContentText_todo" | "TodoListItemPriority_todo">;
  readonly " $fragmentType": "TodoListItem_todo";
};
export type TodoListItem_todo$key = {
  readonly " $data"?: TodoListItem_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItem_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItem_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ordinal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "response",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedBody",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canChangeStatus",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemMainContentText_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemPriority_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemFooter_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoCircleStatusWithResponse_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemMainContentDetails_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemHeader_todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "9bbbc549f8e7c8987896fcee009cf98d";

export default node;
